/**
 * Cortex Adventure — Data barrel export.
 *
 * All 4 adventure paths + hub routing data + type definitions.
 */

export type {
  AdventureLine,
  AdventureScene,
  AdventurePath,
  HubEvent,
} from './paths';

export { MEMORY_LAYER_PATH } from './memory-layer';
export { COST_ENGINE_PATH } from './cost-engine';
export { PORTFOLIO_BRAIN_PATH } from './portfolio-brain';
export { THE_FUTURE_PATH } from './the-future';

export {
  PROVIDERS,
  ROUTING_TABLE,
  ANTHROPIC_BASELINE,
  getAllModels,
  getProviderByName,
} from './hub-routing';
export type { ModelInfo, ProviderInfo, RouteEntry } from './hub-routing';

// ── All paths in display order ───────────────────────────

import { MEMORY_LAYER_PATH } from './memory-layer';
import { COST_ENGINE_PATH } from './cost-engine';
import { PORTFOLIO_BRAIN_PATH } from './portfolio-brain';
import { THE_FUTURE_PATH } from './the-future';
import type { AdventurePath, AdventureScene } from './paths';

export const ALL_PATHS: AdventurePath[] = [
  MEMORY_LAYER_PATH,
  COST_ENGINE_PATH,
  PORTFOLIO_BRAIN_PATH,
  THE_FUTURE_PATH,
];

/** Flat lookup: scene ID -> scene */
export const SCENE_MAP: Record<string, AdventureScene> = {};
for (const path of ALL_PATHS) {
  for (const scene of path.scenes) {
    SCENE_MAP[scene.id] = scene;
  }
}
